<template>
  <div>
    <head-Back title="隐私政策"></head-Back>
    <div v-if="!iosflag" class="arreement">
      <h3>应用权限</h3>
      <p
        class="desc"
      >感谢您信任并使用本应用的产品和服务，本应用的主要申请权限如下：</p>

      <p class="title_small">一、我们收集的信息</p>
      <p class="desc">
        应用在语音时需要用到麦克风<br/>
        应用在个人资料编辑时，编辑头像时使用相机<br/>
        应用分区域个性化推荐时需要定位<br/>
        应用需要此权限保存个人资料头像图片等<br/>
        应用在个人资料编辑时需要访问相册<br/>
      </p>
      
    </div>
  </div>
</template>
<script>
import headBack from "../common/head-back-no-refresh";
import store from "@/store";

export default {
  name: "app",
  data() {
    return {
      msg: "隐私协议",
      iosflag: true
    };
  },

  mounted() {
    this.$point.init(new Date());
    store.dispatch("hideLoading");
      if (ua.indexOf("T00991") > -1) {
      this.iosflag = true;
    } else {
      this.iosflag = false;
    } 
  },
  created() {
    var ua = navigator.userAgent;
    console.log(ua.indexOf("T00991")+"0000")
    if (ua.indexOf("T00991") > -1) {
      this.iosflag = true;
    } else {
      this.iosflag = false;
    }
  },
  components: {
    headBack
  }
};
</script>
<style  scoped>
#app {
  width: 750px;
  height: 1334px;
}

.arreement {
  padding: 32px 58px 80px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(48, 48, 48, 1);
  line-height: 40px;
}

.arreement h3 {
  width: 610px;
  height: 50px;
  font-size: 36px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 600;
  color: rgba(48, 48, 48, 1);
  line-height: 50px;
}
.arreement p {
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(48, 48, 48, 1);
  line-height: 40px;
  text-align: left;
}
.arreement .arreement .title {
  text-align: left;
  padding-bottom: 30px;
  font-weight: bold;
  font-size: 32px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 500;
  color: rgba(48, 48, 48, 1);
  line-height: 44px;
}
.arreement .title_small {
  padding-top: 20px;
  line-height: 26px;
}

.arreement span {
  color: red;
  text-decoration: underline red;
}

.arreement .bold {
  font-weight: bold;
}
.arreement .text_line {
  text-decoration: underline;
}
.desc-com{
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/agreement/appFunctionRight.vue